import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import CreateJobInput from '../CreateJob/CreateJobInput'

function CreateJobOnboarding({ showModal, setShowModal }) {
  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        Create Job On-Boarding
      </ModalHeader>
      <ModalBody className='scrollbar'>
        <div className='d-flex flex-wrap w-100' style={{ gap: '0rem 1rem' }}>
          <CreateJobInput
            id='type'
            placeholder='Select Type'
            label='Type'
            required={true}
            fullSize={false}
            select={true}
            options={[
              { name: 'Internal', value: 'internal' },
              { name: 'Client', value: 'client' },
            ]}
          />
          <CreateJobInput
            id='jobCandidate'
            placeholder='Select Job Candidate'
            label='Job Candidate'
            required={true}
            fullSize={false}
            select={true}
            options={[]}
          />
          <CreateJobInput
            id='joiningDate'
            label='Joining Date'
            required={true}
            fullSize={false}
            type='date'
          />
          <CreateJobInput
            id='daysOfWeek'
            placeholder='Enter Days Of Week'
            label='Days Of Week'
            required={true}
            fullSize={false}
            type='number'
          />
          <CreateJobInput
            id='salary'
            placeholder='Enter Salary'
            label='Salary'
            fullSize={false}
            type='number'
          />
          <CreateJobInput
            id='salaryType'
            placeholder='Standard Payslip'
            label='Salary Type'
            fullSize={false}
            select={true}
            options={[]}
          />
          <CreateJobInput
            id='salaryDuration'
            placeholder='Select Salary Duration'
            label='Salary Duration'
            fullSize={false}
            select={true}
            options={[]}
          />
          <CreateJobInput
            id='jobType'
            placeholder='Select Job Type'
            label='Job Type'
            fullSize={false}
            select={true}
            options={[]}
          />
          <CreateJobInput
            id='status'
            placeholder='Select Status'
            label='Status'
            fullSize={false}
            select={true}
            options={[]}
          />
          <CreateJobInput
            id='status'
            placeholder='Select Status'
            label='Status'
            fullSize={false}
            select={true}
            options={[]}
            visibility='invisible'
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <CancelModalButton></CancelModalButton>
        <SubmitModalButton text='Create'></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default CreateJobOnboarding
